import { buttonSharedStates } from '@shared/utils/style/buttons';
import { ButtonV2, InputV2Props, styled, Toggle } from '@withjoy/joykit';

export const StyledActionButton = styled(ButtonV2)`
  ${buttonSharedStates};
`;

export const inputOverrides: InputV2Props['overrides'] = {
  Root: {
    props: {
      _hover: {
        borderColor: 'mono14',
      },
    },
  },
};

export const StyledToggle = styled(Toggle)`
  input:checked ~ .joykit-choice-indicator {
    background-color: ${({ theme }) => theme.colors.mono14};
  }
  input ~ .joykit-choice-indicator {
    width: 56px;
    background-color: ${({ theme }) => theme.colors.mono7};
  }
  input:checked ~ .joykit-choice-indicator::before {
    transform: translateY(-50%) translateZ(0.1px) translateX(27px) !important;
  }
  input:disabled ~ .joykit-choice-indicator {
    background-color: ${({ theme }) => theme.colors.mono3};
  }
`;
